// extracted by mini-css-extract-plugin
export default {"progressContainer":"style_progressContainer__qnDrO","progressHeading":"style_progressHeading__P3Ijc","progressHeadingIcon":"style_progressHeadingIcon__u6c12"};